/** @sfdc-extension-file SFDC_EXT_TICKER */
import type { ReactElement } from 'react';
import { useMatches } from 'react-router';
import { Ticker } from '@/extensions/ticker/components/ticker';
import type { PageWithComponentData } from '@/lib/page-designer/page-loader.server';

type AppLayoutLoaderData = {
    ticker?: Promise<PageWithComponentData | null> | PageWithComponentData | null;
};

function hasTickerData(value: unknown): value is AppLayoutLoaderData {
    return typeof value === 'object' && value !== null && 'ticker' in value;
}

/**
 * UITarget component used by the app shell insertion point.
 * Reads `_app` loader data from active route matches and renders ticker only
 * when ticker data is available in the current layout.
 */
export default function TickerTarget(): ReactElement | null {
    const appLayoutMatch = useMatches().find((match) => hasTickerData(match.data));
    const ticker = appLayoutMatch && hasTickerData(appLayoutMatch.data) ? appLayoutMatch.data.ticker : null;

    if (!ticker) {
        return null;
    }

    return <Ticker page={ticker} />;
}
